import { addressToScriptHash, common, OutputModel, utils } from '@neo-one/client-common';
export const output = (outputLike) => new OutputModel({
    address: common.stringToUInt160(addressToScriptHash(outputLike.address)),
    asset: common.stringToUInt256(outputLike.asset),
    value: utils.bigNumberToBN(outputLike.value, 8),
});

//# sourceMappingURL=output.js.map
